import { render, staticRenderFns } from "./NoNotificationsCard.vue?vue&type=template&id=29d2d621&"
import script from "./NoNotificationsCard.vue?vue&type=script&lang=ts&"
export * from "./NoNotificationsCard.vue?vue&type=script&lang=ts&"
import style0 from "./NoNotificationsCard.vue?vue&type=style&index=0&id=29d2d621&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
